module.exports = __webpack_public_path__ + "img/17.76efdd4b.png";